import RuleSettingsModel from '../models/RuleSettingsModel';

export default {
    pathTemplate: 'api/v1.1/game/{gamePk}/feed/live?language={language}&hydrate=ruleSettings&fields=gameData,ruleSettings',
    expires: false,
    model: RuleSettingsModel
};
